import type {HostMap} from '../../../types'

export const TESTING = {
  account: 'delivery-frontend-account-yango.delivery.tst.yandex.net',
  auth: 'delivery-frontend-auth-yango.delivery.tst.yandex.net',
  route: 'ddelivery-frontend-route-yango.delivery.tst.yandex.net',
  tariffs: 'delivery-frontend-tariffs-lb-yango.delivery.tst.yandex.net',
  yaAuthProxy: {
    default: 'ya-authproxy.tst.yango.com',
    authorized: 'ya-authproxy.tst.yango.com',
  },
  avatars: 'avatars.mdst.yango.tech',
  passport: {
    default: 'passport-test.yango.com',
    id: 'id-test.yango.com',
    api: 'api.passport-test.yango.com',
  },
} as const satisfies HostMap
